import React from 'react';
import { Link, useSearchParams } from 'react-router';
import { Dropdown } from 'react-bootstrap';
import ROUTES from '../../constants/routes';
import { isNewDashboardTutorialDeferred } from '../../utils/newDashboardTutorialUtils';
import { useAuth } from '../../redux/ducks/auth';

/**
 * Account-menu entry back into the dashboard tutorial, shown only to a patient who
 * skipped it and asked to see it later.
 *
 * Self-contained so UserAvatarMenu keeps taking no props. It is a Link rather than
 * a click handler because the tour only exists on the account home page while this
 * menu renders on every dashboard page — the request travels as a search param and
 * the page starts the tour when it sees it.
 *
 * @returns {JSX.Element|null}
 */
export const DashboardTutorialMenuItem = () => {
	//#region useSearchParams
	const [searchParams] = useSearchParams();
	//#endregion

	//#region useAuth
	const { profile } = useAuth();
	//#endregion

	if (!isNewDashboardTutorialDeferred(profile)) return null;

	//#region handlers
	const buildLink = () => {
		const updatedParams = new URLSearchParams(searchParams);
		updatedParams.set('tour', 'resume');
		return { pathname: ROUTES.ACCOUNT, search: updatedParams.toString() };
	};
	//#endregion

	//#region Render
	return (
		<Dropdown.Item as={Link} to={buildLink()}>
			View the dashboard tutorial
		</Dropdown.Item>
	);
	//#endregion
};
